// extracted by mini-css-extract-plugin
module.exports = {"solPrice":"NFTMakeOfferSection_solPrice__GatSS","dollarPrice":"NFTMakeOfferSection_dollarPrice__I1c7q","border_top":"NFTMakeOfferSection_border_top__H8phk"};